import React, { useContext, useState, useEffect } from 'react'
import ReportBoard from 'src/pages/ReportsPages/ReportsBoard/ReportBoard'
import { ContextReports } from 'src/context/ContextReports'
import ModalUploadFiles from 'src/components/reports/reportsBoard/ModalUploadFiles'
import boardReportsService from 'src/services/boardReportsService'
import ModalPrevViewFiles from 'src/components/reports/reportsBoard/ModalPrevViewFiles '

const ReportBoardContainer = () => {
  const { urlReport, prevfile, setPrevFile } = useContext(ContextReports)
  const [open, setOpenUpload] = useState(false)
  const [openPrev, setOpenPrev] = useState(false)
  const [loading, setLoading] = useState(false)
  const [url, setUrl] = useState([])

  useEffect(() => {
    if (urlReport.download && !open) {
      setOpenUpload(!open)
    }
  }, [urlReport])

  const handleSaveUploadFile = async (item) => {
    const response = await boardReportsService.uploadFile(item)
    if (response === 1) {
      setOpenUpload(!open)
    }
  }

  useEffect(() => {
    if (prevfile.download && prevfile.openP) {
      setOpenPrev(!openPrev)
    }
  }, [prevfile.openP])

  const handlePrevView = async (item) => {
    setLoading(true)
    const response = await boardReportsService.prevUploadFile(item)
    setUrl(response)
    setLoading(false)
  }

  return (
    <>
      <ModalUploadFiles
        open={open}
        loading={loading}
        section={urlReport}
        handleClose={() => setOpenUpload(!open)}
        handleSaveUploadFile={handleSaveUploadFile}
      />
      {openPrev && (
        <ModalPrevViewFiles
          open={openPrev}
          section={prevfile}
          url={url}
          handleClose={() => {
            setOpenPrev(!openPrev)
            setPrevFile({ openP: false })
            setUrl([])
          }}
          handlePrevView={handlePrevView}
        />
      )}
      <ReportBoard urlReport={urlReport} />
    </>
  )
}

export default ReportBoardContainer
